import moment from "moment-jalaali";
import get from "lodash/get";
import { HistoryTypes } from "../container/Support/TicketDetail/types";
import { columnItemTypes } from "../components/Table/types";
import orderBy from "lodash/orderBy";

const subString = (str: string, length: number = 45) => {
  let title = "";
  if (str?.length >= length) {
    title = str;
    str = `${str.substr(0, length)}...`;
  }
  return { title, str };
};

const viewCategory = (cat: string) => {
  switch (cat) {
    case "POINT_TO_POINT": {
      return "Point to Point";
    }
    case "TD_LTE": {
      return "TD-LTE";
    }
    default: {
      return cat;
    }
  }
};

const calculateServiceTime = (
  startTime: number | string = 0,
  expireTime: number | string = 0,
  baseInterval: string = ""
) => {
  let start = moment(startTime, "X");
  let expire = moment(expireTime, "X");
  let now = moment().startOf("day");
  let total = expire.diff(start, "days");

  if (baseInterval.length) {
    let arrayBase = baseInterval.split("-");
    if (arrayBase && arrayBase.length === 2) {
      const count = Number(arrayBase[0]);
      const period = arrayBase[1];
      if (period === "DAY") {
        total = count;
      } else if (period === "WEEK") {
        total = count * 7;
      } else if (period === "MONTH") {
        total = count * 30;
      } else if (period === "YEAR") {
        total = count * 365;
      }
    }
  }

  let formatedENExpire = "";
  let formatedFAExpire = "";
  if (expireTime !== 0) {
    formatedENExpire = moment(expireTime, "X").format("D MMM YYYY");
    moment.loadPersian();
    formatedFAExpire = moment(expireTime, "X").format("jD jMMMM jYYYY");
  }

  return {
    value: expire.diff(now, "days") <= 0 ? 0 : expire.diff(now, "days"),
    total,
    formatedFAExpire,
    formatedENExpire,
  };
};

const lastStatusHistories = (historyData: { finished?: boolean; history?: Array<HistoryTypes> }) => {
  let histories = get(historyData, "history", []);
  let userTasks = histories.filter((item: HistoryTypes) => item.type === "userTask");
  let status = "";
  if (historyData.finished) {
    status = "پایان یافته";
  } else {
    if (userTasks.length && get(userTasks[userTasks.length - 1], "endTime", undefined) === undefined) {
      if (userTasks[userTasks.length - 1].customer) {
        status = "در انتظار پاسخ";
      } else {
        status = "در حال پی‌گیری";
      }
    }
  }
  return status;
};

const lastDepartmentHistories = (historyData: { finished?: boolean; history?: Array<HistoryTypes> }) => {
  let histories = get(historyData, "history", []);
  let userTasks = histories.filter((item: HistoryTypes) => item.type === "userTask");
  let userTasksReverse = userTasks.reverse();
  let department = "-";
  let departmentItem = userTasksReverse.find(
    (item: HistoryTypes) => item.variables.department_role && item.customer !== true
  );
  if (departmentItem && departmentItem.formFields) {
    let indexFormField = departmentItem.formFields.findIndex((item: any) => item.key === "department_role");
    if (indexFormField > -1) {
      let formFieldItem = departmentItem.formFields[indexFormField];
      let indexValue = get(formFieldItem, "values", []).findIndex(
        (item: any) => item.key === get(departmentItem, "variables.department_role", "")
      );
      if (indexValue > -1) {
        department = get(formFieldItem, `values[${indexValue}].value`, "-");
      }
    }
  }

  if (department === "-") {
    let startItem = histories.find((item) => item.type === "startEvent");
    if (get(startItem, "key", "").length) {
      let departmentRoleKey = get(startItem, "variables.department_role", "");
      if (departmentRoleKey.length) {
        let formFieldItem = get(startItem, "formFields", []).find((item) => item.key === "department_role");
        let values = get(formFieldItem, "values", []);
        let indexDepartment = values.findIndex((item) => item.key === departmentRoleKey);
        if (indexDepartment > -1) {
          department = get(values[indexDepartment], "value", "-");
        }
      }
    }
  }
  return department;
};

const lastUpdateDateHistories = (historyData: { finished?: boolean; history?: Array<HistoryTypes> }) => {
  let histories = get(historyData, "history", []);
  let userTasks = histories.filter((item: HistoryTypes) => item.type === "userTask");
  let userTasksReverse = userTasks.reverse();
  let lastUpdateDate = get(
    userTasksReverse.find((item: HistoryTypes) => item.startTime),
    "startTime",
    0
  );
  return lastUpdateDate > 0 ? moment(lastUpdateDate, "X").format("jYYYY/jMM/jDD") : "-";
};

const taskSubject = (historyData: { finished?: boolean; history?: Array<HistoryTypes> }) => {
  let histories = get(historyData, "history", []);
  let indexStartCustomer = histories.findIndex((item: HistoryTypes) => item.type === "startEvent" && item.customer);
  let subject = "-";
  if (indexStartCustomer > -1) {
    let history = histories[indexStartCustomer];
    subject = get(history, "variables.form_subject", "-");
  }
  return subject;
};

const statusFinancial = (type: string) => {
  switch (type) {
    case "CONFIRMED":
      return "تایید شده";
    case "CANCELED":
      return "کنسل شده";
    case "INITIAL":
      return "پیش نویس";
    case "CASH":
      return "نقد";
    case "CARD":
      return "کارتخوان";
    case "CARD_TO_CARD":
      return " کارت به کارت";
    case "CHEQUE":
      return "چک";
    case "SETTLE":
      return "واریز";
    case "E_PAYMENT":
      return "پرداخت الکترونیک";
    case "RETURN_DEPOSIT":
      return "بازگشت ودیعه";
    case "DUE_NOTE":
      return "دریافت از اعتبار";
    case "SERVICE_INSTEAD":
      return " دریافت خدمات ";
    case "VIRTUAL_TEMPORARY":
      return "موقت مجازی";
    case "VERIFIED":
      return "تایید اولیه";
    case "BANK_GATEWAY":
      return "درگاه بانک";
    default:
      return "-";
  }
};

const calculateCurrency = (amount: number | string) => (amount ? amount.toLocaleString("fa") : 0);

const calculateTableData = (data: any, column: columnItemTypes) => {
  let type = column.type;
  let pathData = get(column, "pathData", "");
  if (type === "string") {
    return get(data, pathData, "-");
  } else if (type === "dateTime") {
    let dateTime = get(data, pathData, 0);
    return dateTime > 0 ? moment(dateTime, "X").format("HH:mm:ss jYYYY/jMM/jDD") : "-";
  } else if (type === "date") {
    let dateTime = get(data, pathData, 0);
    return dateTime > 0 ? moment(dateTime, "X").format("jYYYY/jMM/jDD") : "-";
  } else if (type === "currency") {
    return calculateCurrency(get(data, pathData, ""));
  } else if (type === "statusFinancial") {
    return statusFinancial(get(data, pathData, ""));
  } else if (type === "multiLang") {
    let result = "";
    let results = JSON.parse(get(data, pathData, ""));
    let index = results.findIndex((item: { lang: string; value: string }) => item.lang === "fa");
    if (index > -1) {
      result = results[index].value;
    }
    return result;
  } else if (type === "select") {
    return get(
      get(column, "items", []).find((item) => item.key === get(data, pathData, "")),
      "value",
      "-"
    );
  } else {
    return "-";
  }
};

const getLabelReceiptType = (receiptType: string, field: string) => {
  if (receiptType === "CHEQUE") {
    if (field === "bankDocumentNumber") {
      return "شماره چک";
    } else if (field === "bankDocumentDate") {
      return "زمان چک";
    } else if (field === "chequeOwnerName") {
      return "صاحب حساب";
    } else if (field === "chequeAccountNumber") {
      return "شماره حساب";
    }
  } else if (receiptType === "SETTLE") {
    if (field === "bankDocumentNumber") {
      return "شماره واریزی";
    } else if (field === "bankDocumentDate") {
      return "زمان واریز";
    }
  } else if (receiptType === "E_PAYMENT" || receiptType === "CARD" || receiptType === "BANK_GATEWAY") {
    if (field === "bankDocumentNumber") {
      return "شماره پیگیری";
    } else if (field === "bankDocumentDate") {
      return "زمان پرداخت";
    }
  } else if (receiptType === "RETURN_DEPOSIT") {
    if (field === "bankDocumentNumber") {
      return "شماره واریزی";
    } else if (field === "bankDocumentDate") {
      return "زمان واریز";
    }
  } else if (receiptType === "CARD_TO_CARD") {
    if (field === "bankDocumentNumber") {
      return "شماره ارجاع";
    } else if (field === "bankDocumentDate") {
      return "تاریخ انتقال";
    } else if (field === "chequeOwnerName") {
      return "شماره کارت";
    }
  } else {
    return "";
  }
};

const identificationLabel = (type: string) => {
  switch (type) {
    case "PASSPORT_ID": {
      return "شماره گذرنامه";
    }
    case "LOGISTIC_CARD_ID": {
      return "شماره کارت آمایش";
    }
    case "REFUGE_CARD_ID": {
      return "شناسه کارت پناهندگی";
    }
    case "IDENTITY_CARD_ID": {
      return "شماره کارت هویت";
    }
    case "NATIONAL_ID": {
      return "کدملی";
    }
    default: {
      return "-";
    }
  }
};

const exportFileURL = (id: string, type?: string) => {
  switch (type) {
    case "invoices": {
      return `${process.env.REACT_APP_BSS_SERVICE}/api/portal/factors/me/invoices/${id}/export-file`;
    }
    case "deposits": {
      return `${process.env.REACT_APP_BSS_SERVICE}/api/portal/deposits/${id}/export-file`;
    }
    case "return-invoices": {
      return `${process.env.REACT_APP_BSS_SERVICE}/api/portal/factors/me/return-invoices/${id}/export-file`;
    }
    default: {
      return "";
    }
  }
};

const calculateTimeIntervalList = (intervalList: any, defaultInterval: any) => {
  let defaultTimeIntervalKey = get(defaultInterval, "key", "");
  let defaultTimeInterval = defaultInterval;
  let timeIntervalList: { key?: string; value?: string }[] = [];
  orderBy(intervalList, ["timeAmount", "asc"]).forEach(
    (item: { key: string; offeringIntervalType?: string; title: string }) => {
      if (
        item.offeringIntervalType !== "ONLY_ONE_RENEW" &&
        item.offeringIntervalType !== "ONLY_FIRST" &&
        item.key !== "2-MONTH" &&
        item.key !== "1-DAY" &&
        item.key !== "7-DAY" &&
        item.key !== "1-WEEK" &&
        item.key !== "2-DAY"
      ) {
        timeIntervalList.push({
          key: item.key,
          value: item.title,
        });
      } else if (item.offeringIntervalType === "ONLY_ONE_RENEW") {
        if (
          item.key !== defaultTimeIntervalKey &&
          item.key !== "1-DAY" &&
          item.key !== "2-MONTH" &&
          item.key !== "7-DAY" &&
          item.key !== "1-WEEK" &&
          item.key !== "2-DAY"
        ) {
          timeIntervalList.push({
            key: item.key,
            value: item.title,
          });
        }
        if (item.key === defaultTimeIntervalKey) {
          defaultTimeInterval = {};
        }
      }
    }
  );
  if (defaultTimeInterval.key === undefined) {
    const access = ["3-MONTH", "6-MONTH", "12-MONTH"];
    for (let i = 0; i < access.length; i++) {
      let index = timeIntervalList.findIndex((obj) => obj.key === access[i]);
      if (index > -1) {
        defaultTimeInterval = timeIntervalList[index];
        break;
      }
    }
  }
  return { defaultTimeInterval, timeIntervalList };
};

const durationIsLessThanFourDays = (from: any, to: any) => {
  if (from && to) {
    let fromDate = moment(from, "X");
    let toDate = moment(to, "X");
    return toDate.diff(fromDate, "days") <= 4;
  } else {
    return false;
  }
};

const getDataLabels = (list: any, key: any, defaultFormat: any) => {
  let result = [];
  if (list && list.length) {
    result = list.map((item: any) => moment(item[key], "X").format(defaultFormat));
  }
  return result;
};

const getDataValues = (list: any, key: any) => {
  let result = [];
  if (list && list.length) {
    result = list.map((item: any) => item[key]);
  }
  return result;
};

const requiredValueReseller = [
  "form_lead_name",
  "form_customer_medium_mobile",
  "form_customer_medium_phone",
  "form_customer_party_type",
  "form_customer_medium_province_city",
  "form_customer_medium_district",
  "form_customer_medium_address",
  "form_sales_has_coverage",
  "form_customer_purchase_order",
  "form_customer_purchase_order_interval",
  "form_customer_introduction_way",
];

type ViewInvoiceTypes = ViewInvoiceItemType[];
type ViewInvoiceItemType = {
  id: string;
  name: string;
  amount: number;
};
type InvoiceItemListType = {
  calculateItemType: string;
  description: string;
  amount: number;
};
const generatedInvoiceItemList = (
  array: any = [],
  currentDebit: number = 0,
  depositItemList: any = [],
  depositAmount: number = 0,
  balanceAmount: number = 0,
  showDebt: boolean = false,
  gatewaySettle: boolean = false
) => {
  let invoiceItemList: ViewInvoiceTypes = [];
  let taxPlusToll = 0;
  let totalAmount = 0;
  let valueTaxAndToll = 0;
  let deposits: any = [];
  let totalAmountFactor = 0;
  depositItemList.forEach((item: { calculateItemType: string }) => {
    if (item.calculateItemType !== "TOTAL") {
      if (item.calculateItemType === "SUB_TOTAL") {
        item.calculateItemType = "SUB_TOTAL_DEPOSIT";
      }
      deposits.push(item);
    }
  });
  array = [...deposits, ...array];
  array.forEach((item: InvoiceItemListType, index: number) => {
    let invoiceItem = { id: "-1", name: "", amount: 0 };
    if (item.calculateItemType === "PLUS") {
      invoiceItem = {
        id: index.toString(),
        name: item.description,
        amount: item.amount,
      };
    } else if (item.calculateItemType === "MINUS") {
      invoiceItem = {
        id: index.toString(),
        name: item.description,
        amount: item.amount,
      };
    } else if (item.calculateItemType === "SUB_TOTAL_DEPOSIT") {
      invoiceItem = {
        id: index.toString(),
        name: item.description,
        amount: item.amount,
      };
    } else if (item.calculateItemType === "TOLL") {
      taxPlusToll += item.amount;
      const description = (item?.description || "").split("%");
      if (description && description.length === 2) {
        valueTaxAndToll += Number(description[0]);
      }
    } else if (item.calculateItemType === "TAX") {
      taxPlusToll += item.amount;
      const description = (item?.description || "").split("%");
      if (description && description.length === 2) {
        valueTaxAndToll += Number(description[0]);
      }
    } else if (item.calculateItemType === "TOTAL") {
      totalAmount = item.amount + currentDebit;
      totalAmount = item.amount + depositAmount;
      totalAmountFactor = totalAmount;
      if (balanceAmount > 0) {
        totalAmount = item.amount + balanceAmount;
      }
      invoiceItem = {
        id: index.toString(),
        name: "مبلغ قابل پرداخت",
        amount: totalAmount,
      };
    }
    if (invoiceItem.id !== "-1") {
      invoiceItemList.push(invoiceItem);
    }
  });
  invoiceItemList.splice(invoiceItemList.length - 1, 0, {
    id: `${valueTaxAndToll}٪ مالیات و ارزش افزوده`,
    name: `${valueTaxAndToll}٪ مالیات و ارزش افزوده`,
    amount: taxPlusToll,
  });

  if (showDebt && balanceAmount > 0) {
    invoiceItemList.splice(invoiceItemList.length - 1, 0, {
      id: "جمع نهایی فاکتور",
      name: "جمع نهایی فاکتور",
      amount: totalAmount - balanceAmount,
    });
    invoiceItemList.splice(invoiceItemList.length - 1, 0, {
      id: "بدهی پیشین",
      name: "بدهی پیشین",
      amount: currentDebit,
    });
  }
  if (gatewaySettle && currentDebit > 0) {
    invoiceItemList.splice(invoiceItemList.length - 1, 0, {
      id: "بدهی پیشین",
      name: "بدهی پیشین",
      amount: currentDebit,
    });
    invoiceItemList.splice(invoiceItemList.length - 1, 0, {
      id: "مبلغ قابل پرداخت",
      name: "مبلغ قابل پرداخت",
      amount: totalAmount + currentDebit,
    });
    invoiceItemList.pop();
    totalAmount += currentDebit;
  }

  return {
    invoiceItemList,
    totalAmount,
    totalAmountFactor,
  };
};

const findMaxAndTarget = (array: Record<any, any>[], TN: number) => {
  const sortedArray = array.sort((a, b) => b.timeAmount - a.timeAmount);

  if (sortedArray[0].timeAmount === TN) {
    return array.slice(0, 1);
  }

  return sortedArray.filter((obj) => obj.timeAmount > TN);
};
const calculateUpgradePromotion = (params: {
  defaultTimeInterval?: Record<any, any>;
  timeIntervalList?: Record<any, any>[];
  timeIntervalListOriginal?: Record<any, any>[];
}) => {
  const { defaultTimeInterval = {}, timeIntervalList = [], timeIntervalListOriginal = [] } = params;
  let timeInterval: Record<any, any> = { ...defaultTimeInterval };
  let timeIntervals: Record<any, any>[] = timeIntervalList.map((item) => ({
    ...item,
    timeAmount: timeIntervalListOriginal.find((obj) => obj.key === item.key)?.timeAmount,
  }));

  timeIntervals = findMaxAndTarget(timeIntervals, defaultTimeInterval.timeAmount).reverse();
  if (timeIntervals.length > 0) {
    const find = timeIntervalListOriginal.find(
      (item) => item.timeAmount === timeIntervals[timeIntervals.length - 1]?.timeAmount
    );

    timeInterval = {
      ...timeInterval,
      timeUnit: find?.timeUnit,
      timeAmount: find?.timeAmount,
      title: find?.title,
      key: find?.key,
    };
  }

  return {
    timeInterval,
    timeIntervals,
  };
};

const persianNumber: Record<any, any> = {
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9",
};
const persianNumberToENNumber = (number: string | number = "") => {
  const result = number.toString();
  return result
    .split("")
    .map((num: string) => persianNumber[num] || num)
    .join("");
};

const enNumberToPersianNumber = (number: string | number = "") =>
  number.toString().replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);

const validProductIds = [
  "90f3baa8-1d49-4a85-b025-fff56bfd3b38",
  "29e03ebc-cf57-4cc5-a47f-7a289f6c61a0",
  "33c0d1f5-e3d5-4e83-af7a-f1d7c45c5a96",
  "dcc21730-3f99-4ead-b506-4c9dff82dee7",
  "1dceb436-0f5c-4758-97fb-4bc3b412ec5c",
  "06683b02-b64e-4bde-bc70-0630e018b8cc",
  "d9d467f9-3c30-4711-8e47-1658176979e5",
  "894d964b-2273-4791-89e6-d04c508f7abe",
  "2f600118-74b5-4727-8d38-faa414091591",
  "7ac4f6cf-9914-4934-bf1b-960c87a03515",
  "05873ab0-c9f1-4879-b6ff-9af27462996d",
  "bb17fa99-4618-4c10-b633-ac7957796d93",
  "05b723a9-b1b7-4f03-a7db-5a805714e2d7",
];

export {
  subString,
  viewCategory,
  calculateServiceTime,
  lastStatusHistories,
  lastDepartmentHistories,
  lastUpdateDateHistories,
  taskSubject,
  calculateTableData,
  getLabelReceiptType,
  calculateCurrency,
  identificationLabel,
  exportFileURL,
  calculateTimeIntervalList,
  durationIsLessThanFourDays,
  getDataLabels,
  getDataValues,
  requiredValueReseller,
  generatedInvoiceItemList,
  statusFinancial,
  calculateUpgradePromotion,
  persianNumberToENNumber,
  enNumberToPersianNumber,
  validProductIds,
};
